<template>
  <div class="content">
    <div class="container">
      <div class="login-form">
        <div class="main-div">
          <div class="panel"><h1>Login</h1></div>
          <form @submit="formSubmit" id="login">
            <div class="data-login">
              <div class="form-group">
                <input class="form-control"
                       id="email"
                       name="email"
                       placeholder="Enter your E-mail address"
                       required
                       type="email"
                       v-model="email">
              </div>
              <div class="form-group">
                <input class="form-control"
                       name="password"
                       placeholder="Enter your password"
                       required
                       type="password"
                       v-model="password">
              </div>
            </div>


            <div class="row justify-content-center">
              <button class="btn btn-primary" type="submit">Login</button>
            </div>
          </form>
          <!--                    <div class="forgot">-->
          <!--                        <button class="btn btn-danger" role="link">Forgot password?</button>-->
          <!--                    </div>-->
          <!--                    <div class="row justify-content-center">-->
          <!--                        <span class="font-medium">Don't have an account? </span>-->
          <!--                        <a class="normal" href="#/auth/register"> Sign up now</a>-->
          <!--                    </div>-->

        </div>

      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: "LoginPage",

    mounted() {
      console.info(this.$apiUrl);
    },

    data() {
      return {
        email: '',
        password: ''
      }
    },

    methods: {
      formSubmit(e) {
        e.preventDefault();
        this.$http.post('auth/login', {
          'email': this.email,
          'password': this.password
        }).then(result => {
          localStorage.setItem('isAdmin', result.data.isAdmin);
          localStorage.setItem('email', result.data.email);
          this.$router.push('/')
        }, error => {
          console.error(error);
        });
      }
    }
  }
</script>

<style scoped>

  .container {
    max-width: 500px;
  }

  .panel h1 {
    color: #444444;
    font-size: 45px;
    margin: 0 0 30px 0;
  }

  .panel p {
    color: #777777;
    font-size: 14px;
    margin-bottom: 30px;
    line-height: 24px;
  }

  .login-form .form-control {
    background: #f7f7f7 none repeat scroll 0 0;
    border: 1px solid #d4d4d4;
    border-radius: 4px;
    font-size: 14px;
    height: 50px;
    line-height: 50px;
  }

  .data-login {
    margin-bottom: 20px;
  }

  .main-div {
    background: white none repeat scroll 0 0;
    border-radius: 20px;
    margin: 10px auto 30px;
    max-width: 100%;
    padding: 30px 30px 10px 30px;
  }

  .login-form .form-group {
    margin-bottom: 15px;
  }

  .login-form {
    text-align: center;
    padding-top: 45%;
    padding-bottom: 48%;

  }

  /*footer {
    margin-top: 20%;
  }*/

  .forgot a {
    color: #777777;
    font-size: 14px;
    text-decoration: underline;
  }

  .login-form .btn.btn-primary {
    background: red none repeat scroll 0 0;
    border-color: red;
    color: #ffffff;
    font-size: 25px;
    width: 90%;
    height: 50px;
    line-height: 50px;
    padding: 0;
    margin-bottom: 25px
  }

  .btn-danger {
    background: #9fb3bd none repeat scroll 0 0;
    border-color: #9fb3bd;
    color: #ffffff;
    font-size: 14px;
    width: 50%;
    height: 40px;
    line-height: 40px;
    padding: 0;
    margin-left: 50%;

  }

  .forgot {
    text-align: left;
    margin-bottom: 30px;
  }

  .login-form .btn.btn-primary.reset {
    background: #ff9900 none repeat scroll 0 0;
  }

  .back {
    text-align: left;
    margin-top: 10px;
  }

  .back a {
    color: #444444;
    font-size: 13px;
    text-decoration: none;
  }


</style>
